import { laptopMediumMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import { MAX_WIDTH } from '../layout/PageWrapper.style';

export const Wrapper = styled.div`
  margin: 0 auto 60px;
  max-width: ${MAX_WIDTH}px;
  width: 100%;
  padding: 0 30px;

  @media (${laptopMediumMax}) {
    padding: 0 15px;
  }
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  gap: 30px;

  @media (${laptopMediumMax}) {
    flex-direction: column-reverse;
    gap: 60px;
  }
`;

export const RankingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-left: 1px solid ${({ theme }) => theme.backgroundLight};
  padding-left: 30px;

  @media (${laptopMediumMax}) {
    padding-left: 0;
    border: none;
  }
`;

export const RosetteContainer = styled.div`
  position: relative;
  margin: 30px auto;
`;

export const RosetteText = styled.p`
  width: 100%;
  text-align: center;
  position: absolute;
  top: 34px;
  font-weight: bold;
  font-size: 32px;
`;
